var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading center-items"},[_c('svg',[_c('circle',{attrs:{"cx":"70","cy":"70","r":"70"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }